/**
 * CreditReminderCard - info card explaining how credits are billed.
 *
 * Shared by the paste-text input and the file/image upload panel so the
 * billing reminder renders identically in both. Presentational only; the
 * caller supplies the already-translated message as children.
 */

import type { ReactNode } from "react";
import { Info } from "lucide-react";

interface CreditReminderCardProps {
  children: ReactNode;
  "data-test"?: string;
}

export function CreditReminderCard(
  { children, "data-test": dataTest }: CreditReminderCardProps,
) {
  return (
    <div
      data-test={dataTest}
      className="mt-4 mb-2 flex items-start gap-2 rounded-[var(--r-lg)] border border-[var(--border)] bg-[var(--accent)] px-3 py-3 text-xs text-[var(--accent-foreground)]"
    >
      <Info className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
